import { defineMessages } from 'react-intl';

/**
 * Shared shell/label strings for the Freight Details view.
 *
 * Kept intentionally minimal in Phase 1 — only the top-level view title is
 * defined here. Per-component strings live in co-located `*-messages.ts` files
 * (e.g. the status badge and detail section). This grows as the shell, detail
 * sections, and mapper land in later phases.
 */
export const freightDetailsMessages = defineMessages({
  title: {
    defaultMessage: 'Freight Details',
    id: 'sQ3cm0',
    description: 'Title of the freight shipment details view',
  },
  bolTitle: {
    defaultMessage: 'BOL #{bolNumber}',
    id: 'xDp1e8',
    description: 'Freight Details title bar heading showing the bill of lading number',
  },
  share: {
    defaultMessage: 'Share',
    id: 'I5vOJC',
    description: 'Label for the button that shares the freight shipment',
  },
  print: {
    defaultMessage: 'Print',
    id: 'PW446j',
    description: 'Label for the button that prints all freight shipment documents',
  },
  closeAriaLabel: {
    defaultMessage: 'Close freight details',
    id: 'dM8Xdd',
    description: 'Accessible label for the freight details drawer close button',
  },
  shipmentActions: {
    defaultMessage: 'Shipment Actions',
    id: 'd7/FAg',
    description: 'Label for the menu of actions that can be taken on a freight shipment',
  },
  voidMenuItem: {
    defaultMessage: 'Void',
    id: 'wl64xc',
    description: 'Label for the Void action in the freight shipment actions menu',
  },
  orderLink: {
    defaultMessage: 'Order #{orderNumber}',
    id: 'sAQFkL',
    description: 'Link in the freight details drawer that navigates back to the related order',
  },
});
